<app-vvr-icon [full]="true" [dark]="true" [overlay]="true" [shadow]="false"></app-vvr-icon>
<div class="login-background">
    <form [formGroup]="loginForm" class="login-form">
        <h1 class="h2 condensed">Inloggen</h1>
        <mat-form-field appearance="fill" id="email">
            <mat-label>E-mailadres</mat-label>
            <input formControlName="email" matInput name="email" placeholder="Vul hier uw e-mailadres in" type="text">
            @if (loginForm.invalid) {
                <mat-error>Vul een correct e-mailadres in</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="fill" id="password">
            <mat-label>Wachtwoord</mat-label>
            <input formControlName="password" matInput name="password" placeholder="Wat is uw wachtwoord?" type="password">
            @if (loginForm.invalid) {
                <mat-error>Vul uw wachtwoord in</mat-error>
            }
        </mat-form-field>

        <div class="login-buttons">
            <button (click)="login()" [disabled]="loginForm.invalid" color="primary" id="btn-login" mat-raised-button>
                @if (loginFormState() == LoginFormState.FillIn) {
                    Inloggen
                } @else if (loginFormState() == LoginFormState.Login) {
                    Aan het inloggen...
                }
            </button>
            <button (click)="forgotPassword()" class="me-2" id="btn-lost-password" mat-button>
                Wachtwoord vergeten
            </button>
        </div>

        @if (errorMessage()) {
            <div id="errorMessage">
                <i class="fa fa-warning"></i>{{errorMessage()}}
            </div>
        }

        <div class="links">
            <h1 class="h5 condensed">Kennismaken met onze app?</h1>
            <img class="float-right" width="90" src="/assets/logos/VVR_b-rood.svg"/>
            <a href="tel:+31172619238" target="_BLANK">
                <i class="fa fa-phone float-left"></i> 0172 61 92 38
            </a>
            <a href="mailto:vanvelsen@vvr.nl" target="_BLANK">
                <i class="fa fa-envelope float-left"></i> vanvelsen&#64;vvr.nl
            </a>
            <a href="https://vvr.nl" target="_BLANK">
                <i class="fa fa-globe float-left"></i> vvr.nl
            </a>
        </div>

    </form>
</div>
